// photos
import emixPhoto1 from "../../assets/images/PhotographyProjects/emix-photo-1.jpeg";
import emixPhoto2 from "../../assets/images/PhotographyProjects/emix-photo-2.jpg";
import emixPhoto3 from "../../assets/images/PhotographyProjects/emix-photo-3.jpg";
import emixPhoto4 from "../../assets/images/PhotographyProjects/emix-photo-4.jpeg";
import emixPhoto5 from "../../assets/images/PhotographyProjects/emix-photo-5.jpeg";
import emixPhoto6 from "../../assets/images/PhotographyProjects/emix-photo-6.png";
import emixPhoto7 from "../../assets/images/PhotographyProjects/emix-photo-7.jpeg";
import emixPhoto8 from "../../assets/images/PhotographyProjects/emix-photo-8.jpg";
import emixPhoto9 from "../../assets/images/PhotographyProjects/emix-photo-9.jpeg";
import emixPhoto10 from "../../assets/images/PhotographyProjects/emix-photo-10.jpeg";
import emixPhoto11 from "../../assets/images/PhotographyProjects/emix-photo-11.jpeg";
import emixPhoto12 from "../../assets/images/PhotographyProjects/emix-photo-12.jpeg";
import emixPhoto13 from "../../assets/images/PhotographyProjects/emix-photo-13.jpeg";
import emixPhoto14 from "../../assets/images/PhotographyProjects/emix-photo-14.jpeg";
import emixPhoto15 from "../../assets/images/PhotographyProjects/emix-photo-15.png";
// import emixPhoto16 from "../../assets/images/PhotographyProjects/emix-photo-16.jpg";
import emixPhoto17 from "../../assets/images/PhotographyProjects/emix-photo-17.jpeg";
import emixPhoto18 from "../../assets/images/PhotographyProjects/emix-photo-18.jpeg";
import emixPhoto19 from "../../assets/images/PhotographyProjects/emix-photo-19.jpeg";
import emixPhoto20 from "../../assets/images/PhotographyProjects/emix-photo-20.jpeg";
import emixPhoto21 from "../../assets/images/PhotographyProjects/emix-photo-21.jpeg";
import emixPhoto22 from "../../assets/images/PhotographyProjects/emix-photo-22.jpeg";
import emixPhoto23 from "../../assets/images/PhotographyProjects/emix-photo-23.png";
import emixPhoto24 from "../../assets/images/PhotographyProjects/emix-photo-24.jpeg";
import emixPhoto25 from "../../assets/images/PhotographyProjects/emix-photo-25.jpeg";
import emixPhoto26 from "../../assets/images/PhotographyProjects/emix-photo-26.jpeg";
import emixPhoto27 from "../../assets/images/PhotographyProjects/emix-photo-27.jpeg";

export const photos = [
     emixPhoto1,
     emixPhoto2,
     emixPhoto3,
     emixPhoto4,
     emixPhoto5,
     emixPhoto6,
     emixPhoto7,
     emixPhoto8,
     emixPhoto9,
     emixPhoto10,
     emixPhoto11,
     emixPhoto12,
     emixPhoto13,
     emixPhoto14,
     emixPhoto15,
     emixPhoto17,
     emixPhoto18,
     emixPhoto19,
     emixPhoto20,
     emixPhoto21,
     emixPhoto22,
     emixPhoto23,
     emixPhoto24,
     emixPhoto25,
     emixPhoto26,
     emixPhoto27,

];